import styled from 'styled-components';
import {Collapse} from "antd";

export const CollapseStyled = styled(Collapse)`
    border: none;
    
    .ant-collapse-expand-icon {
        height: 25px!important;
    }
    .ant-collapse-header-text {
        font-size: 16px;
        font-weight: 600;
    }
    .ant-collapse-content {
        border-top: 1px solid #d9d9d9!important;
    }

    .ant-collapse-item-disabled > .ant-collapse-header {
        color: inherit;
        cursor: inherit;
    }
`;